import { Notices } from 'components/notice/notices'
import { useMemo } from 'react'
import { Navigate, useParams } from 'react-router-dom'
import { useFeatureFlag } from 'services/feature-flags'
import { useAccountStore, useAssetStore } from 'store'
import { PageTitle } from 'utils/page-title'
import { FormSpamProvider, FormSpamPage } from '../form-spam'
import { createLeadFormsApi } from './api'
import { createDemoLeadFormsApi } from './demo'

export const LeadFormsPage = () => {
	const { accountId, assetId } = useParams<{
		accountId: string
		assetId: string
	}>()
	const leadFormsEnabled = useFeatureFlag('form-protection-enabled')
	const account = useAccountStore((s) => s.account)
	const hasLeadForms = useAccountStore((s) => s.hasFeature('lead_forms'))
	const hasDashboardPerformance = useAccountStore((s) =>
		s.hasFeature('dashboard_performance')
	)
	const asset = useAssetStore((s) => s.asset)
	const adAccounts = useAssetStore((s) => s.adAccounts)
	const isDemo = assetId === 'website-demo'
	const api = useMemo(
		() =>
			isDemo
				? createDemoLeadFormsApi()
				: createLeadFormsApi(accountId || '', assetId || ''),
		[accountId, assetId, isDemo]
	)

	if (
		!leadFormsEnabled ||
		(!isDemo && (!hasLeadForms || !asset?.tc_first_installed_at))
	) {
		return <Navigate to=".." replace />
	}

	return (
		<>
			<PageTitle pageName="Lead Forms" />
			<div className="flex min-h-full flex-col">
				{
					<Notices
						isInSetup={account?.status === 'SETUP'}
						setupStep={account?.setup?.step}
						isInActive={account?.status === 'INACTIVE'}
						hasDashboardPerformanceFeature={hasDashboardPerformance}
						tc_installed={!!asset?.tc_installed}
						cc_installed={!!asset?.cc_installed}
						tc_installed_skipped={!!asset?.tc_installed_skipped}
						accountId={accountId}
						assetId={assetId}
						demoMode={isDemo}
						mccLinkInviteAdAccounts={adAccounts}
					/>
				}
				{accountId && assetId && (
					<FormSpamProvider key={`${accountId}/${assetId}`} api={api}>
						<FormSpamPage />
					</FormSpamProvider>
				)}
			</div>
		</>
	)
}
